import { useAppContextNonNull } from "@contexts/AppContext";
import Catalogs from "../Catalogs/Catalogs";
import ScreenOptionsEnum from "@models/ScreenOptionsEnum";
import { hasEditAccess } from "@services/ScreenOptionsService";
import ViewAccessService from "@services/ViewAccessService";
import { useMemo } from "react";

export const CatalogsWrapper = () => {
    const { userModel, supplierModel, socket, uiContext } = useAppContextNonNull();

    const isReadOnly = useMemo(() => {
        return !hasEditAccess(ScreenOptionsEnum.CATALOGS, userModel, supplierModel, ViewAccessService.Catalogs);
    }, [userModel, supplierModel]);

    return (
        <Catalogs
            userModel={userModel}
            supplierModel={supplierModel}
            socket={socket}
            notifyFn={uiContext.notifyFn}
            toggleSidebar={uiContext.toggleSidebar}
            setActivityIndicator={uiContext.setActivityIndicator}
            setSidebarComponent={uiContext.setSidebarComponent}
            showHiddenFeatures={uiContext.showHiddenFeatures}
            isReadOnly={isReadOnly}
            uiContext={uiContext}
        />
    );
};
